import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/lib/theme";
import { cn } from "@/lib/cn";

type Props = {
  className?: string;
};

export function ThemeToggle({ className }: Props) {
  const { theme, toggle } = useTheme();
  const next = theme === "dark" ? "light" : "dark";

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={`Switch to ${next} mode`}
      title={`Switch to ${next} mode`}
      className={cn(
        "relative grid h-10 w-10 place-items-center rounded-full border border-line/70 text-ink/80",
        "bg-surface-raised/60 backdrop-blur transition-all duration-300",
        "hover:border-accent hover:text-accent focus-ring",
        className,
      )}
    >
      <span className="sr-only">Toggle theme</span>
      <Sun
        className={cn(
          "absolute h-[18px] w-[18px] transition-all duration-300",
          theme === "dark" ? "-rotate-90 scale-50 opacity-0" : "rotate-0 scale-100 opacity-100",
        )}
        strokeWidth={1.5}
      />
      <Moon
        className={cn(
          "absolute h-[18px] w-[18px] transition-all duration-300",
          theme === "dark" ? "rotate-0 scale-100 opacity-100" : "rotate-90 scale-50 opacity-0",
        )}
        strokeWidth={1.5}
      />
    </button>
  );
}
